// extracted by mini-css-extract-plugin
module.exports = {"main":"Login_main__3ph32","content":"Login_content__3jyOJ"};